/**
 * This script manages the mobile sticky bar's size selector on a product page.
 * It updates the displayed size options and active size label according to changes in size scale,
 * selected size, and gender, staying in sync with the main product display.
 */

document.addEventListener('DOMContentLoaded', () => {
    mobileStickyBar();
  });
  
  function mobileStickyBar() {
    // =============================================================================
    // INITIAL SETUP
    // =============================================================================
  
    // Get main product container for references to active gender and product type
    const productContainer = document.querySelector('.js-main-product [data-active-gender]');
    if (!productContainer) {
      console.warn('No productContainer found with [data-active-gender].');
      return;
    }
  
    // Get references to the mobile sticky bar elements and buy buttons
    const mobileBar = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper');
    const mobileBarSelect = mobileBar?.querySelector('.mobile-sticky-select');
    const mobileActiveSize = mobileBar?.querySelector('.mobile-active-size');
    const buyBtns = document.querySelector('.js-main-product .buy_buttons__wrapper');
  
    // Ensure all necessary elements exist before proceeding
    if (!mobileBar || !mobileBarSelect || !mobileActiveSize || !buyBtns) {
      console.warn('Mobile sticky bar elements not found or buy buttons missing.');
      return;
    }
  
    // =============================================================================
    // STICKY BAR VISIBILITY
    // =============================================================================
  
    // Show/hide the mobile sticky bar based on the visibility of the buy buttons
    const viewportObserver = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && entry.boundingClientRect.top <= 0) {
        mobileBar.classList.add('is-visible');
      } else {
        mobileBar.classList.remove('is-visible');
      }
    });
    viewportObserver.observe(buyBtns);
  
    // =============================================================================
    // POPULATING THE MOBILE SIZE SELECTOR
    // =============================================================================
  
    function populateMobileBarSelect() {
      // Clear existing options
      mobileBarSelect.innerHTML = '';
  
      // Fetch current scale and product attributes
      const dropdownButton = document.getElementById('product-size-dropdown-button');
      const selectedLocation = (dropdownButton?.dataset.selectedLocation || 'US').toLowerCase();
      const activeGender = productContainer.getAttribute('data-active-gender');
      const productType = productContainer.getAttribute('data-product-type');
  
      const isGiftCardProduct = productContainer.hasAttribute('data-gift-card-product');
      const isMultiGenderProduct = productContainer.hasAttribute('data-multi-gender-product');
      const isUnisexProduct = productContainer.hasAttribute('data-unisex-product');
  
      // Determine the gender key for scale attributes
      let genderKey;
      if (activeGender === 'women') {
        genderKey = 'women';
      } else if (activeGender === 'men') {
        genderKey = 'men';
      } else {
        genderKey = null;
      }
  
      // Determine which data attribute to use for scaled sizes
      let scaleDataAttr;
      if (isGiftCardProduct) {
        scaleDataAttr = 'data-value';
      } else if (productType === 'Footwear' && genderKey) {
        scaleDataAttr = `data-size-${genderKey}-${selectedLocation}`;
      } else {
        scaleDataAttr = 'data-default-value';
      }
  
      // Gather currently visible size options
      const allSizes = Array.from(document.querySelectorAll('.js-main-product .size-inputs-wrapper .size_value'))
        .filter(valueEl => {
          const label = valueEl.closest('label');
          return label && label.style.display !== 'none';
        });
  
      let checkedOptionValue = null; // Track which option should be selected in the dropdown
  
      // Build dropdown options
      allSizes.forEach(valueEl => {
        const option = document.createElement('option');
        const labelValue = valueEl.textContent.trim();
  
        // Find the associated input element for this size
        const labelEl = valueEl.closest('label');
        let parentInput = null;
        if (labelEl) {
          const forValue = labelEl.getAttribute('for');
          parentInput = forValue ? document.getElementById(forValue) : null;
        }
  
        // Determine the actual scaled value to display
        const scaleValue = parentInput ? (parentInput.getAttribute(scaleDataAttr) || labelValue) : labelValue;
        option.value = scaleValue;
  
        // Format option text based on product type and attributes
        let optionText;
        if (isGiftCardProduct) {
          optionText = scaleValue; // Gift card uses the scale value directly
        } else if (isMultiGenderProduct || isUnisexProduct) {
          // Multi-gender/unisex: include gender and location, e.g. "women's EU 36"
          optionText = `${activeGender}'s ${selectedLocation.toUpperCase()} ${scaleValue}`;
        } else {
          // Normal product: "US 5"
          optionText = `${selectedLocation.toUpperCase()} ${scaleValue}`;
        }
  
        option.textContent = optionText;
        mobileBarSelect.appendChild(option);
  
        // If this input is checked, remember it to set as selected later
        if (parentInput && parentInput.checked) {
          checkedOptionValue = scaleValue;
        }
      });
  
      // If we have a checked input, set the dropdown's value to it
      if (checkedOptionValue) {
        mobileBarSelect.value = checkedOptionValue;
      }
    }
  
    // =============================================================================
    // SYNCING THE ACTIVE SIZE LABEL
    // =============================================================================
  
    function syncMobileActiveSize() {
      const sizeOptionSpan = document.querySelector('#product-size-dropdown-button .size-option_label');
      if (sizeOptionSpan && mobileActiveSize) {
        mobileActiveSize.textContent = sizeOptionSpan.textContent;
      }
    }
  
    // Initial population and sync
    populateMobileBarSelect();
    syncMobileActiveSize();
  
    // =============================================================================
    // EVENT LISTENERS FOR UPDATES
    // =============================================================================
  
    // When the size scale changes (e.g., from US to EU)
    document.addEventListener('sizeScaleUpdated', () => {
      console.log('sizeScaleUpdated event received');
      populateMobileBarSelect();
      syncMobileActiveSize();
    });
  
    // When a new size is selected in the main product area
    document.addEventListener('sizeSelected', (e) => {
      console.log('sizeSelected event received', e.detail);
      if (e.detail && e.detail.labelText && mobileActiveSize) {
        mobileActiveSize.textContent = e.detail.labelText;
      }
    });
  
    // When the gender changes
    document.addEventListener('genderUpdated', () => {
      console.log('genderUpdated event received');
      populateMobileBarSelect();
      syncMobileActiveSize();
    });
  
    // =============================================================================
    // HANDLING USER SELECTION FROM THE MOBILE STICKY BAR
    // =============================================================================
  
    mobileBarSelect.addEventListener('change', () => {
      const productSizes = Array.from(document.querySelectorAll('.js-main-product .size-inputs-wrapper input'));
      const dropdownButton = document.getElementById('product-size-dropdown-button');
      const selectedLocation = (dropdownButton?.dataset.selectedLocation || 'US').toLowerCase();
      const activeGender = productContainer.getAttribute('data-active-gender');
      const productType = productContainer.getAttribute('data-product-type');
      const isGiftCardProduct = productContainer.hasAttribute('data-gift-card-product');
      const isMultiGenderProduct = productContainer.hasAttribute('data-multi-gender-product');
      const isUnisexProduct = productContainer.hasAttribute('data-unisex-product');
  
      let genderKey;
      if (activeGender === 'women') {
        genderKey = 'women';
      } else if (activeGender === 'men') {
        genderKey = 'men';
      } else {
        genderKey = null;
      }
  
      let dataSize;
      if (isGiftCardProduct) {
        dataSize = 'data-value';
      } else if (productType === 'Footwear' && genderKey) {
        dataSize = `data-size-${genderKey}-${selectedLocation}`;
      } else {
        dataSize = 'data-default-value';
      }
  
      // Match the selected option to the correct input and trigger its change event
      const productSize = productSizes.find(input => {
        const attrVal = input.getAttribute(dataSize);
        return attrVal === mobileBarSelect.value;
      });
  
      if (productSize) {
        productSize.checked = true;
        productSize.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }